import shop from '../../api/shop'
const service_Categories = [{
        id: 1,
        title: "Women’s Wear",
        row: "category",
        action: "far fa-arrow-alt-circle-down",
        items: [
            { id: 1, title: "Saree", price: 20, p_price: 40 },
            { id: 2, title: "Three piece", price: 15, p_price: 30 },
            { id: 3, title: "Women’s Wear", price: 10, p_price: 20 }
        ]
    },
    {
        id: 2,
        title: "Men’s Wear",
        row: "category",
        items: [
            { id: 4, title: "Panjabi", price: 20, p_price: 40 },
            { id: 5, title: "Shirt", price: 15, p_price: 30 },
            { id: 6, title: "Pant", price: 10, p_price: 20 }
        ]
    },
    {
        id: 3,
        title: "Kids Wear",
        row: "category",
        items: [
            { id: 7, title: "Half Pent", price: 20, p_price: 40 },
            { id: 8, title: "Full Shirt", price: 15, p_price: 30 },
            { id: 9, title: "T - shirt", price: 10, p_price: 20 }
        ]
    },
    {
        id: 4,
        title: "Household & Accessories",
        row: "category",
        items: [{ id: 10, title: "Shawls", price: 20, p_price: 40 }]
    }
];

// initial state
const state = {
    all: []
}

// getters
const getters = {};

// actions
const actions = {
    getAllProducts({ commit }, items) {
        commit("setProducts", (items || service_Categories));
    }
    // getAllProducts({ commit }) {
    //   shop.getProducts(products => {
    //     commit('setProducts', products)
    //   })
    // }
};

// mutations
const mutations = {
    setProducts(state, products) {
        state.all = products;
    },

    updateAProduct(state, product) {
        const newItems = state.all.map(obj => {
            obj.items = obj.items.map(obj2 => {
                if (product.id == obj2.id) {
                    obj2.cartQty = product.cartQty;
                    obj2.cartServiceType = product.cartServiceType;
                }
                return obj2;
            });

            return obj;
        });
        state.all = newItems;
    },

    removeCartProperties(state, product) {
        const newItems = state.all.map(obj => {
            obj.items = obj.items.map(obj2 => {
                if (product.id == obj2.id) {
                    obj2.cartQty = 1;
                    delete obj2.cartServiceType;
                }
                return obj2;
            });

            return obj;
        });
        state.all = newItems;
        console.log(newItems);
    },

    decrementProductInventory(state, { id }) {
        const product = state.all.find(product => product.id === id);
        product.inventory--;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};